import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {DynFormData} from '../domain/data/dyn-form-data';
import {Observable} from 'rxjs/Observable';
import {FormDataService} from './form-data.service';
import {FormService} from './form.service';

@Injectable()
export class FormDataResolveService implements Resolve<DynFormData> {
    constructor(
        private formDataService: FormDataService,
        private formService: FormService,
        private router: Router
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<DynFormData> {

        if (route.params['dataId']) {
            return this.formDataService.get(+route.params['dataId'])
        } else if (route.params['formId']) {
            return this.formService.get(+route.params['formId'])
                .map(form => DynFormData.createEmpty(form));
        } else {
            this.router.navigate(['home', 'forms', 'data']);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/forms/services/form-data-resolve.service.ts